import { Offcanvas, Form, Button } from "react-bootstrap";
import { REACT_SELECT_STYLES, PLANTING_STATUS } from "configurations/Constants";
import {
  LABEL_SELECT_CROP,
  LABEL_SELECT_SEED_TYPE,
  LABEL_SELECT_STATUS,
  LABEL_SELECT_TILLAGE,
} from "configurations/MessageConstants";
import Select from "react-select";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setSelectedCrops,
  setSelectedSeeds,
  setSelectedStatus,
  setSelectedTillages,
  setIsFilterApplied,
  resetPlantedAcresDrawerFilters,
} from "reduxStore/slices/plantedAcresFilterSlice";

const PlantedAcresFilter = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const {
    selectedCrops,
    selectedSeeds,
    selectedStatus,
    selectedTillages,
    isFilterApplied,
  } = useSelector((state) => state.plantedAcresFilter);
  const [filterSelectedCrops, setFilterSelectedCrops] = useState([]);
  const [filterSelectedSeeds, setFilterSelectedSeeds] = useState([]);
  const [filterSelectedStatus, setFilterSelectedStatus] = useState([]);
  const [filterSelectedTillages, setFilterSelectedTillages] = useState([]);
  const crops = useSelector((state) => state.site.crops);
  const seeds = useSelector((state) => state.site.seeds);
  const tillages = useSelector((state) => state.site.tillages);

  const CROPS_OPTIONS = crops.map((crop) => ({
    value: crop,
    label: crop,
  }));

  const SEEDS_OPTIONS = seeds.map((seed) => ({
    value: seed,
    label: seed,
  }));

  const STATUS_OPTIONS = Object.values(PLANTING_STATUS).map((status) => ({
    value: status,
    label: status,
  }));

  const TILLAGES_OPTIONS = tillages.map((tillage) => ({
    value: tillage,
    label: tillage,
  }));

  useEffect(() => {
    if (show) {
      setFilterSelectedCrops(selectedCrops);
      setFilterSelectedSeeds(selectedSeeds);
      setFilterSelectedStatus(selectedStatus);
      setFilterSelectedTillages(selectedTillages);
    }
  }, [show, selectedCrops, selectedSeeds, selectedStatus, selectedTillages]);

  const handleClear = () => {
    setFilterSelectedCrops([]);
    setFilterSelectedSeeds([]);
    setFilterSelectedStatus([]);
    setFilterSelectedTillages([]);
  };

  const handleApply = () => {
    dispatch(setSelectedCrops(filterSelectedCrops));
    dispatch(setSelectedSeeds(filterSelectedSeeds));
    dispatch(setSelectedStatus(filterSelectedStatus));
    dispatch(setSelectedTillages(filterSelectedTillages));

    const hasFilters =
      filterSelectedCrops.length > 0 ||
      filterSelectedSeeds.length > 0 ||
      filterSelectedStatus.length > 0 ||
      filterSelectedTillages.length > 0;

    dispatch(setIsFilterApplied(hasFilters));
    handleClose();
  };
  const handleReset = () => {
    if (!isFilterApplied) return;
    handleClear();
    dispatch(resetPlantedAcresDrawerFilters());
    handleClose();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      aria-labelledby="planted-acres-filter"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title
          id="planted-acres-filter"
          className="w-100 d-flex align-items-center justify-content-between"
        >
          <span>Planted Acres Filter</span>
          <Button
            variant="link"
            onClick={handleReset}
            className="filter-reset-button"
            aria-label="Reset Filters"
          >
            <span className="filter-reset-button-text">Reset</span>
            <i className="fa fa-refresh"></i>
          </Button>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-3">
          <Form.Label>Crop</Form.Label>
          <Select
            isMulti
            value={filterSelectedCrops}
            onChange={setFilterSelectedCrops}
            options={CROPS_OPTIONS}
            placeholder={LABEL_SELECT_CROP}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Crop"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Seed Type</Form.Label>
          <Select
            isMulti
            value={filterSelectedSeeds}
            onChange={setFilterSelectedSeeds}
            options={SEEDS_OPTIONS}
            placeholder={LABEL_SELECT_SEED_TYPE}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Seed Type"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Tillage</Form.Label>
          <Select
            isMulti
            value={filterSelectedTillages}
            onChange={setFilterSelectedTillages}
            options={TILLAGES_OPTIONS}
            placeholder={LABEL_SELECT_TILLAGE}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Tillage"
          />
        </Form.Group>
        <Form.Group className="mb-4">
          <Form.Label>Status</Form.Label>
          <Select
            isMulti
            value={filterSelectedStatus}
            onChange={setFilterSelectedStatus}
            options={STATUS_OPTIONS}
            placeholder={LABEL_SELECT_STATUS}
            styles={REACT_SELECT_STYLES}
            aria-label="Select Status"
          />
        </Form.Group>
        <div className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PlantedAcresFilter;
